import React from 'react';
import './Glance.css';
import './GlanceStates.css';

import { GlanceV1 } from './GlanceV1';
import { GlanceV2 } from './GlanceV2';

interface GlanceProps { /* The names need to be lowercase for backwards compatibility. */
  groupid: string;
  authurl?: string;
  puid: string;
  openlocation?: string;
  iframeid?: string;
  gicon?: boolean;
  presence?: boolean;
  glancebaseurl?: string;
  visitorid?: string;
  debugmode?: boolean;
  custominvoke?: () => void;
  customopenwindow: boolean;
  presession?: () => void;
  authheaders?: object;
  authbody?: URLSearchParams;
  authmethod: string;
  openwindow?: (url: string) => void;
  autojoin?: boolean;
  errormessage?: string;
  reportingcallback?: (sessionData: HistoricalReportingData) => void;
  reportingorigin?: string;
  reportingexternalid?: string;
  uiversion?: number;
}
export interface HistoricalReportingData {
  sessionId: string;
  sessionStart: string;
  sessionEnd: string;
  duration: number;
}

export const Glance = (props: GlanceProps) => {
  console.log(`Glance UI version: ${props.uiversion}`);
  return props.uiversion == 2 ? (
    <GlanceV2
      groupId={props.groupid}
      authUrl={props.authurl}
      puid={props.puid}
      openlocation={'tab'}
      presence={true}
      glanceBaseUrl={props.glancebaseurl}
      visitorId={props.visitorid}
      debugMode={props.debugmode}
      gicon={props.gicon == undefined || props.gicon}
      authMethod={props.authmethod}
      authHeaders={props.authheaders}
      authBody={props.authbody}
      openWindow={props.customopenwindow ? props.openwindow : undefined}
      reportingCallback={props.reportingcallback}
      reportingOrigin={props.reportingorigin}
      reportingExternalId={props.reportingexternalid}
      autoJoin={props.autojoin}
      errorMessage={props.errormessage}
      customOpenWindow={props.customopenwindow}
      uiVersion={2}
    />
  ) : (
    <GlanceV1
      groupId={props.groupid}
      authUrl={props.authurl}
      puid={props.puid}
      openlocation={'tab'}
      presence={true}
      glanceBaseUrl={props.glancebaseurl}
      visitorId={props.visitorid}
      debugMode={props.debugmode}
      gicon={props.gicon}
      authMethod={props.authmethod}
      authHeaders={props.authheaders}
      authBody={props.authbody}
      openWindow={props.customopenwindow ? props.openwindow : undefined}
      reportingCallback={props.reportingcallback}
      reportingOrigin={props.reportingorigin}
      reportingExternalId={props.reportingexternalid}
      autoJoin={props.autojoin}
      errorMessage={props.errormessage}
      customOpenWindow={props.customopenwindow}
      uiVersion={1}
    />
  );
};
